/**
 * ACORDE — Dos retoques a los filtros de Horizon, sin tocar su código:
 *
 * 1. El filtro de intensidad guarda números (1, 2, 3). Aquí se muestran como palabras.
 * 2. Debajo del filtro de precio se agregan atajos ("Hasta $100.000", etc.) que llenan
 *    los campos de mínimo y máximo y disparan el filtrado.
 *
 * Horizon vuelve a pintar los filtros cada vez que cambian, así que ambos retoques se
 * aplican con un observador y son idempotentes.
 */
const PALABRAS_INTENSIDAD = { 1: 'Suave', 2: 'Media', 3: 'Intensa' };

// Límites de los atajos de precio, en pesos. Se ajustan cuando se conozcan los precios reales.
const ATAJOS_PRECIO = [
  { texto: 'Hasta $100.000', min: '', max: '100000' },
  { texto: '$100.000 – $200.000', min: '100000', max: '200000' },
  { texto: 'Más de $200.000', min: '200000', max: '' },
];

function renombrarIntensidad(raiz) {
  for (const entrada of raiz.querySelectorAll('input[name="filter.p.m.acorde.intensidad"]')) {
    const etiqueta = raiz.querySelector(`label[for="${CSS.escape(entrada.id)}"] .checkbox__label-text`)
      || raiz.querySelector(`label[for="${CSS.escape(entrada.id)}"]`);
    if (!etiqueta) continue;
    const palabra = PALABRAS_INTENSIDAD[etiqueta.textContent.trim()];
    if (palabra) etiqueta.textContent = palabra;
  }
}

function agregarAtajosPrecio(raiz) {
  for (const envoltorio of raiz.querySelectorAll('.price-facet__inputs-wrapper')) {
    if (envoltorio.nextElementSibling?.classList.contains('acorde-precio-atajos')) continue;
    const entradas = envoltorio.querySelectorAll('.price-facet__input');
    if (entradas.length < 2) continue;
    const [minimo, maximo] = entradas;

    const fila = document.createElement('div');
    fila.className = 'acorde-precio-atajos';
    for (const atajo of ATAJOS_PRECIO) {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'acorde-precio-atajos__chip';
      chip.textContent = atajo.texto;
      chip.setAttribute('aria-pressed', String(minimo.value === atajo.min && maximo.value === atajo.max));
      chip.addEventListener('click', () => {
        minimo.value = atajo.min;
        maximo.value = atajo.max;
        for (const campo of [minimo, maximo]) {
          campo.dispatchEvent(new Event('input', { bubbles: true }));
          campo.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      fila.appendChild(chip);
    }
    envoltorio.insertAdjacentElement('afterend', fila);
  }
}

function aplicar() {
  renombrarIntensidad(document);
  agregarAtajosPrecio(document);
}

let pendiente = null;
const observador = new MutationObserver(() => {
  if (pendiente) return;
  pendiente = requestAnimationFrame(() => {
    pendiente = null;
    aplicar();
  });
});

aplicar();
observador.observe(document.body, { childList: true, subtree: true });
